module.exports = __webpack_public_path__ + "static/media/016.bc0ba5e2.jpg";